export default __webpack_public_path__ + "static/media/plus.ccbe1e49.svg";